<template>
  <card-edit @edit="$emit('edit')">
    <order-payment
        :order="$store.getters.orderSystem.order"
        :total-amount="$store.getters.orderSystem.cartService.getTotalAmountWithDiscount"
        divider flat
    >
    </order-payment>
  </card-edit>
</template>

<script>
import CardEdit from "@/modules/delivery/components/CardEdit/CardEdit.vue";
import OrderPayment from "@/modules/delivery/components-core/shared/OrderPayment/OrderPayment.vue";

export default {
  name: "OrderReviewPayment",
  components: {OrderPayment, CardEdit},

}
</script>

<style scoped>

</style>
